import api from "./api";

export async function uploadWorkorderAttachment(workorderId, file) {
  const formData = new FormData();
  formData.append("bestand", file);

  const res = await api.post(`/werkbonnen/${workorderId}/bijlage`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function uploadWorkorderAttachments(workorderId, files = []) {
  const successful = [];
  const failed = [];

  for (const file of files) {
    try {
      const response = await uploadWorkorderAttachment(workorderId, file);
      successful.push({ file, response });
    } catch (err) {
      failed.push({
        file,
        message: err?.response?.data?.message || "Bijlage upload mislukt",
      });
    }
  }

  return { successful, failed };
}
